import React from 'react'

function Textanimate() {
  return (
    <div className='mt-60 -rotate-3'>
          <div class="relative w-[120%] h-32 overflow-hidden bg-[#D5FF3C]">  
        <div class="h-full flex items-center uppercase absolute text-black *:mx-5 font-primary animate-animation_text whitespace-nowrap moving-text text-7xl">  
            <span>javascript</span> 
            <span className='font-serif'>&</span> 
            <span>tailwind</span> 
            <span className='font-serif'>&</span> 
            <span>html</span> 
            <span className='font-serif'>&</span>
            <span>css</span> 
            <span className='font-serif'>&</span> 
            <span>react</span> 
            <span className='font-serif'>&</span> 
            <span>git</span> 
            <span className='font-serif'>&</span> 
            <span>nextjs</span> 
            <span className='font-serif'>&</span>
            <span>bootstrap</span> 
            <span className='font-serif'>&</span> 
            <span>sass</span> 

        </div>  
    </div>   
    </div>
  )
}

export default Textanimate